module.exports = __webpack_public_path__ + "img/8.e4a286d4.jpg";